import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import OtpInput from "@/shared/components/common/otp";
import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Dispatch, SetStateAction, useState, useEffect } from "react";

interface JudicialOtpTabProps {
    valueOtp: string;
    setValueOtp: Dispatch<SetStateAction<string>>;
    handleSubmit?: () => void;
    onResendOtp?: () => void;
    isResendingOtp?: boolean;
    timeLeft?: number;
    isWaitingForOtp?: boolean;
    customTimerDuration?: number;
}

const JudicialOtpTab = ({
                            valueOtp,
                            setValueOtp,
                            handleSubmit,
                            onResendOtp,
                            isResendingOtp = false,
                            customTimerDuration = 540,
                        }: JudicialOtpTabProps) => {
    const [externalTimeLeft, setExternalTimeLeft] = useState(customTimerDuration);
    const [isTimerComplete, setIsTimerComplete] = useState(false);

    // Reset timer when customTimerDuration changes
    useEffect(() => {
        setExternalTimeLeft(customTimerDuration);
        setIsTimerComplete(false);
    }, [customTimerDuration]);

    const handleTimerComplete = () => {
        setIsTimerComplete(true);
        console.log("Judicial OTP timer completed!");
        // You can add custom logic here
    };

    const handleResend = () => {
        setExternalTimeLeft(customTimerDuration);
        setIsTimerComplete(false);
        if (onResendOtp) onResendOtp();
    };

    return (
        <StackKit sx={{ width: "100%", height: "100%" }} direction={"row"} justifyContent={"center"} alignItems={"center"}>
            <StackKit direction={"column"} sx={{ width: "80%", minHeight: "400px" }} alignItems={"center"}>
                <TypoGraphyKit variant="h6" sx={{ minHeight: "200px" }}>
                    در این مرحله یک کد امنیتی جهت استعلام قضایی برای شما ارسال میشود. لطفا کد ارسال شده را وارد نمایید.
                    {isTimerComplete && (
                        <span style={{
                            color: "#ff6b6b",
                            display: "block",
                            marginTop: "10px",
                            fontSize: "0.9rem",
                            fontWeight: "bold"
                        }}>
                            ⚠️ زمان وارد کردن کد به پایان رسیده است. لطفا مجدداً درخواست کد کنید.
                        </span>
                    )}
                    {isResendingOtp && (
                        <span style={{
                            color: "#136A74",
                            display: "block",
                            marginTop: "10px",
                            fontSize: "0.9rem"
                        }}>
                            در حال ارسال مجدد کد...
                        </span>
                    )}
                </TypoGraphyKit>
                <BoxKit sx={{ width: "60%" }}>
                    <OtpInput
                        length={5}
                        hasResend
                        value={valueOtp}
                        onChange={setValueOtp}
                        handleSubmit={handleSubmit}
                        onResend={handleResend}
                        initialTimer={customTimerDuration}
                        externalTimeLeft={externalTimeLeft}
                        setExternalTimeLeft={setExternalTimeLeft}
                        onTimerComplete={handleTimerComplete}
                    />
                </BoxKit>
            </StackKit>
        </StackKit>
    );
};

export default JudicialOtpTab;